import { render } from "./PopupDeliver.vue?vue&type=template&id=75aab331&scoped=true"
import script from "./PopupDeliver.vue?vue&type=script&lang=ts"
export * from "./PopupDeliver.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-75aab331"

export default script